import ToolIcon from './ToolIcon'

export default ToolIcon
